module.exports = __webpack_public_path__ + "assets/img/04.6083cb03.png";